import { Dimensions } from 'react-native';

const screenWidth = Dimensions.get('window').width;
const BASE_DESIGN_WIDTH = 400; // Assumed base design width for scaling calculations

export const responsiveFontSize = (baseFontSize) => {
  const scale = screenWidth / BASE_DESIGN_WIDTH;
  let newSize = baseFontSize * scale;

  if (baseFontSize === 44) {
    newSize = Math.max(28, Math.min(newSize, 44));
  } else if (baseFontSize === 40) {
    newSize = Math.max(30, Math.min(newSize, 40));
  } else if (baseFontSize === 32) {
    newSize = Math.max(24, Math.min(newSize, 32));
  } else if (baseFontSize === 18) {
    newSize = Math.max(14, Math.min(newSize, 18));
  } else {
    newSize = Math.max(12, Math.min(newSize, baseFontSize * 1.1));
  }
  return newSize;
};

export const responsiveSpacing = (baseSpacing) => {
  const scale = screenWidth / BASE_DESIGN_WIDTH;
  let newSpacing = baseSpacing * scale;

  if (baseSpacing === 320) {
    newSpacing = Math.max(200, Math.min(newSpacing, 320));
  } else if (baseSpacing === 300) {
    newSpacing = Math.max(200, Math.min(newSpacing, 300));
  } else if (baseSpacing === 64) {
    newSpacing = Math.max(24, Math.min(newSpacing, 64));
  } else {
    newSpacing = Math.max(baseSpacing * 0.6, Math.min(newSpacing, baseSpacing * 1.2));
  }
  return newSpacing;
};
